import { Box, Card, CardContent, Typography } from '@mui/material';
import ReportOffIcon from '@mui/icons-material/ReportOff';
import NoReport from '../../../assets/reports-empty.svg';
import { useTranslation } from 'react-i18next';

const NoReportCard = () => {
  const { t: translate } = useTranslation();
  return (
    <Card 
      sx={{ 
        width: '100%', 
        height: '100%',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        borderRadius: '12px',
        border: '1px solid #e0e0e0',
        backgroundColor: '#fafafa',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
          backgroundColor: '#f5f5f5'
        },
        minHeight: '200px'
      }}
    >
      <CardContent 
        sx={{ 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          '&:last-child': { pb: 3 }
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            mb: 2,
            position: 'relative'
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'rgba(158, 158, 158, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1
            }}
          >
            <img 
              src={NoReport} 
              alt="No Data Available" 
              style={{
                height: 50,
                width: 50,
                opacity: 0.7,
                filter: 'grayscale(20%)'
              }}
            />
          </Box>
        </Box>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: 1.4,
            maxWidth: '200px'
          }}
        >
          {translate('report.no_report')}
        </Typography>
        
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'text.disabled',
            fontSize: '0.75rem',
            mt: 0.5,
            fontStyle: 'italic'
          }}
        >
          No data available
        </Typography>
      </CardContent>
    </Card>
  );
};

export default NoReportCard;
